import {RouteConfig} from "vue-router";
import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import Accounts from "@/pages/Pages/Accounts/Accounts.vue";
import Account from '@/pages/Pages/Accounts/Account.vue';

const accountsMenu: RouteConfig = {
    path: "/",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    children: [
        {
            path: "accounts",
            name: "accounts",
            components: {default: Accounts},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.accounts'
            }
        },
        {
            path: "accounts/new",
            name: "accounts_new",
            components: {default: Account},
            meta: {
                icon: "settings",
                parentPath: "/accounts",
                msgKey: 'menu.item.accounts'
            },
        },
        {
            path: "accounts/:id",
            name: "accounts_edit",
            components: {default: Account},
            meta: {
                icon: "settings",
                parentPath: "/accounts",
                msgKey: 'menu.item.accounts'
            }
        },
    ]
}

export default accountsMenu;
